import { dateUtils } from '@festina-life/core'

import type { TemplateVersionInfo } from '../../types/templateModel'

export const activeVersionForDate = (
  versionInfos: TemplateVersionInfo[],
  atDate: Date,
) =>
  versionInfos.findLast(
    (versionInfo) =>
      !versionInfo.fromDate ||
      versionInfo.fromDate <= dateUtils.dateAsServerStr(atDate),
  )
